var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveNotReceivedEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25674_38944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47716 4.47741C1.78572 4.95921 1.33325 5.76018 1.33325 6.66683V13.3335C1.33325 14.8063 2.52716 16.0002 3.99992 16.0002H11.9999C12.566 16.0002 13.0909 15.8238 13.5227 15.5229M2.47716 4.47741L1.33325 3.3335M2.47716 4.47741L13.5227 15.5229M13.5227 15.5229L14.6666 16.6668M4.66658 4.00016H11.9999C13.4727 4.00016 14.6666 5.19407 14.6666 6.66683V13.3335C14.6666 13.5395 14.6432 13.74 14.599 13.9326M9.59992 8.9335L11.9999 7.3335",
    stroke: "#181D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25674_38944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNotReceivedEmail);
export default __webpack_public_path__ + "static/media/active_not_received_email.60408b2d044d0912f1b21676d0df9247.svg";
export { ForwardRef as ReactComponent };